import { useLocation } from "react-router-dom";
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { Typography } from "antd";

import { savePlan, getDetailPlan, getMedDetail, getPlanLogs } from 'store/eligibility/pac/actions';

import PostAcuteCareClinicalPlanDetail from 'components/Eligibility/MemberEligibilityDetailTables/PostAcuteCareClinicalPlanTab/PostAcuteCareClinicalPlanDetail';

import CarePlanDetailPageProps from './Proptypes';

import './index.scss';

const { Title } = Typography;

const CarePlanDetailPage = (props: CarePlanDetailPageProps) => {
  const location: any = useLocation();

  return (
    <>
      <div className="care-plan-detail-page">
        <div className="header-title">
          <Title level={4} className="ml-3">Member Post Acute Care Plan</Title>
        </div>

        <PostAcuteCareClinicalPlanDetail
          getDetailPlan={props.getDetailPlan}
          getMedDetail={props.getMedDetail}
          getPlanLogs={props.getPlanLogs}
          savePlan={props.savePlan}
          isFetchingPlanLogs={props.isFetchingPlanLogs}
          eligibilityMemberInfo={location.state.eligibilityMemberInfo}
          primaryCareProvider={location.state.primaryCareProvider}
          planId={location.state.planId}
          pacPlan={location.state.pacPlan}
          status={location.state.status}
        />
      </div>
    </>
  );
}

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingPlanLogs: store.rootReducer.eligibilityPAC.isFetchingPlanLogs, //Clinical Plan Notes log table
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getDetailPlan,
    getMedDetail,
    getPlanLogs,
    savePlan
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(CarePlanDetailPage);
